/**
 * Keep the mobile/tablet bottom nav viewport-fixed.
 *
 * The bar is rendered inside the sticky header. On iPad/Safari, position:fixed
 * inside a sticky (or opacity-animated) ancestor scrolls with that ancestor and
 * can appear mid-page. Move the bar to document.body while the bottom-nav
 * breakpoint is active; restore it into the header on desktop.
 *
 * After cart morphs, a fresh header-actions can reappear in the header while the
 * portaled (stale) copy remains in the host — reconcile so only one cart exists.
 */
(function () {
  'use strict';

  var BREAKPOINT = 750;
  var HOST_ID = 'mobile-bottom-nav-host';
  var PLACEHOLDER_ATTR = 'data-mobile-bottom-nav-placeholder';

  var mediaQuery = window.matchMedia('(max-width: ' + (BREAKPOINT - 1) + 'px)');
  var host = null;
  var placeholder = null;
  var bound = false;

  function getHeader() {
    return document.querySelector('#header-component.header--mobile-bottom-nav, .header--mobile-bottom-nav');
  }

  function getAllActions() {
    return Array.prototype.slice.call(
      document.querySelectorAll('header-actions[data-mobile-bottom-nav="true"]')
    );
  }

  function getActions() {
    if (host) {
      var inHost = host.querySelector('header-actions[data-mobile-bottom-nav="true"]');
      if (inHost) return inHost;
    }
    return document.querySelector('header-actions[data-mobile-bottom-nav="true"]');
  }

  function ensurePlaceholder(actions) {
    if (placeholder && placeholder.isConnected) return placeholder;

    var existing = document.querySelector('[' + PLACEHOLDER_ATTR + ']');
    if (existing) {
      placeholder = existing;
      return placeholder;
    }

    placeholder = document.createElement('span');
    placeholder.setAttribute(PLACEHOLDER_ATTR, 'true');
    placeholder.setAttribute('hidden', '');
    placeholder.setAttribute('aria-hidden', 'true');
    placeholder.style.cssText = 'display:none!important;width:0;height:0;overflow:hidden;';

    if (actions.parentNode) {
      actions.parentNode.insertBefore(placeholder, actions);
    }

    return placeholder;
  }

  function syncHostClasses(headerEl) {
    if (!host || !headerEl) return;

    host.className = 'mobile-bottom-nav-host';

    for (var i = 0; i < headerEl.classList.length; i++) {
      var className = headerEl.classList.item(i);
      if (
        className === 'header--mobile-bottom-nav' ||
        (className && className.indexOf('header--mobile-bottom-nav--') === 0)
      ) {
        host.classList.add(className);
      }
    }
  }

  function ensureHost(headerEl) {
    host = document.getElementById(HOST_ID);
    if (!host) {
      host = document.createElement('div');
      host.id = HOST_ID;
      host.className = 'mobile-bottom-nav-host';
      host.setAttribute('data-mobile-bottom-nav-host', 'true');

      var actionsWrap = document.createElement('div');
      actionsWrap.className = 'header__item--actions';
      host.appendChild(actionsWrap);
      document.body.appendChild(host);
    }

    syncHostClasses(headerEl);
    return host;
  }

  function getHostActionsSlot() {
    if (!host) return null;
    return host.querySelector('.header__item--actions') || host;
  }

  function closeCartIn(root) {
    if (!root) return;

    var drawers = root.querySelectorAll('cart-drawer-component');
    for (var i = 0; i < drawers.length; i++) {
      var drawer = drawers[i];
      if (drawer && typeof drawer.close === 'function') {
        try {
          drawer.close();
        } catch (e) {
          /* ignore */
        }
      }
    }

    var dialogs = root.querySelectorAll('dialog[open], .cart-drawer__dialog[open]');
    for (var j = 0; j < dialogs.length; j++) {
      try {
        if (typeof dialogs[j].close === 'function') dialogs[j].close();
        else dialogs[j].removeAttribute('open');
      } catch (e) {
        dialogs[j].removeAttribute('open');
      }
    }
  }

  function isCartOpenIn(root) {
    if (!root) return false;
    return !!root.querySelector(
      'cart-drawer-component dialog[open], cart-drawer-component .cart-drawer__dialog:modal, cart-drawer-component .cart-drawer__dialog[open]'
    );
  }

  function openCartIn(root) {
    if (!root) return;
    if (document.documentElement.hasAttribute('data-pz-suppress-cart-open')) return;
    var drawer =
      root.querySelector('cart-drawer-component[auto-open]') || root.querySelector('cart-drawer-component');
    if (!drawer) return;
    if (typeof drawer.open === 'function') {
      drawer.open();
      return;
    }
    if (typeof drawer.showDialog === 'function') {
      drawer.showDialog();
    }
  }

  function moveToHost(actions, headerEl) {
    ensurePlaceholder(actions);
    ensureHost(headerEl);

    var slot = getHostActionsSlot();
    if (slot && actions.parentNode !== slot) {
      slot.appendChild(actions);
    }

    document.documentElement.setAttribute('data-mobile-bottom-nav-ported', 'true');
  }

  function restoreToHeader(actions) {
    if (placeholder && placeholder.isConnected && placeholder.parentNode) {
      placeholder.parentNode.insertBefore(actions, placeholder);
    }

    document.documentElement.removeAttribute('data-mobile-bottom-nav-ported');
  }

  /**
   * Cart section morph can inject a second header-actions into the header while
   * the portaled copy stays in the host. Keep the freshest (in-header) instance,
   * drop duplicates, and re-portal so only one cart drawer exists.
   */
  function reconcileActions() {
    if (!mediaQuery.matches) return;

    var headerEl = getHeader();
    if (!headerEl) return;

    var all = getAllActions();
    if (all.length === 0) return;

    var wasOpen = false;
    for (var i = 0; i < all.length; i++) {
      if (isCartOpenIn(all[i])) {
        wasOpen = true;
        break;
      }
    }

    var keeper = null;
    for (var j = 0; j < all.length; j++) {
      if (all[j].closest('#' + HOST_ID)) continue;
      if (headerEl.contains(all[j])) {
        keeper = all[j];
        break;
      }
    }
    if (!keeper) {
      keeper =
        (host && host.querySelector('header-actions[data-mobile-bottom-nav="true"]')) || all[0];
    }

    for (var k = 0; k < all.length; k++) {
      if (all[k] === keeper) continue;
      closeCartIn(all[k]);
      if (all[k].parentNode) all[k].parentNode.removeChild(all[k]);
    }

    moveToHost(keeper, headerEl);
    syncHostClasses(headerEl);

    // Drop any leftover open cart dialogs outside the keeper.
    var openDialogs = document.querySelectorAll(
      'cart-drawer-component dialog[open], cart-drawer-component .cart-drawer__dialog:modal, cart-drawer-component .cart-drawer__dialog[open]'
    );
    for (var d = 0; d < openDialogs.length; d++) {
      if (keeper.contains(openDialogs[d])) continue;
      try {
        if (typeof openDialogs[d].close === 'function') openDialogs[d].close();
        else openDialogs[d].removeAttribute('open');
      } catch (e) {
        openDialogs[d].removeAttribute('open');
      }
    }

    if (wasOpen && !isCartOpenIn(keeper)) {
      openCartIn(keeper);
    }
  }

  function scheduleReconcile() {
    queueMicrotask(function () {
      reconcileActions();
      requestAnimationFrame(reconcileActions);
    });
  }

  function sync() {
    var headerEl = getHeader();

    if (!headerEl) {
      document.documentElement.removeAttribute('data-mobile-bottom-nav-ported');
      return;
    }

    if (mediaQuery.matches) {
      reconcileActions();
      var actions = getActions();
      if (!actions) {
        document.documentElement.removeAttribute('data-mobile-bottom-nav-ported');
        return;
      }
      moveToHost(actions, headerEl);
      syncHostClasses(headerEl);
    } else {
      var ported = getActions();
      if (host && ported && ported.closest('#' + HOST_ID)) {
        restoreToHeader(ported);
      }
    }
  }

  function onViewportChange() {
    sync();
  }

  function bind() {
    if (bound) return;
    bound = true;

    if (typeof mediaQuery.addEventListener === 'function') {
      mediaQuery.addEventListener('change', onViewportChange);
    } else if (typeof mediaQuery.addListener === 'function') {
      mediaQuery.addListener(onViewportChange);
    }

    document.addEventListener('shopify:section:load', sync);
    document.addEventListener('shopify:section:reorder', sync);
    document.addEventListener('shopify:section:select', sync);
    window.addEventListener('pageshow', sync);

    // After ATC / quantity morph injects a second header cart, collapse to one.
    document.addEventListener('cart:update', scheduleReconcile);
  }

  function init() {
    bind();
    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
